
import { TagsViewModule, ITagView } from '@/store/modules/tagsView'
import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import router from '@/router'
import ScrollPane from './ScrollPane.vue'
import {IMenuItem} from "@/store/modules/menu";

@Component({
  name: 'TagsView',
  components: {
    ScrollPane
  }
})
export default class extends Vue {
  private affixTags: ITagView[] = []
  private selectedTag?: ITagView;

  constructor() {
    super();

    // const data = sessionStorage.getItem("VisitedViews");
    // if(data){
    //   const views = JSON.parse(data) as ITagView[];
    //   for(const v of views){
    //     TagsViewModule.addView(v);
    //   }
    // }
  }

  @Prop({ default: 0 }) private moduleId!: number
  editableTabsValue = "";
  get visitedViews() {
    return TagsViewModule.visitedViews
  }

  get routes() {
    return router.getRoutes();
  }

  private menusMap(){
    if(this.$store.state.menus.has(this.moduleId)){
      return this.$store.state.menus.get(this.moduleId);
    } else {
      return new Map<string, IMenuItem>();
    }
  }

  @Watch('visitedViews', {deep: true})
  private onTabChange(){
    this.updateCurrentTagPath(false);
    // sessionStorage.setItem("VisitedViews", JSON.stringify(this.visitedViews))
  }

  @Watch('$route')
  private onRouteChange() {
    this.updateCurrentTagPath(true);
  }

  mounted() {
    this.initTags()
  }

  private selectTag2(tab: any){
    const obj = this.visitedViews.find(e=>e.key == tab.name);
    if(obj){
      this.selectTag(obj);
    }
  }
  private selectTag(tag: ITagView){
    const ot = TagsViewModule.visitedViews.find(v => v.active);
    if(ot){
      ot.active = false;
    }

    tag.active = true;

    return false;
  }

  private isAffix(tag: ITagView) {
    return tag.meta && tag.meta.affix
  }

  private filterAffixTags(menus: Array<IMenuItem>, basePath = '/') {
    let tags: ITagView[] = []
    menus.forEach(menu => {
      if (menu.affix) {
        const tagPath = (basePath + menu.url).replace('//','/');
        const route = this.$router.getRoutes().find(r => r.path === tagPath);
        const routeName = route !== undefined ? route.name : "";
        tags.push({
          title: menu.name,
          key: menu.url,
          path: menu.url,
          routeName: routeName!,
          module: menu.moduleId,
          meta:{
            affix: true
          },
          active: false,
          history: []
        })
      }
    })
    return tags
  }

  private initTags() {
    const menus = this.menusMap();
    if(menus.size > 0){
      this.affixTags = this.filterAffixTags([...menus.values()])
      for (const tag of this.affixTags) {
        TagsViewModule.addVisitedView(tag)
      }
    }
  }
  private updateCurrentTagPath(replace: boolean){
    // todo
    console.log(this.visitedViews)
    const tag = this.visitedViews.find(v => v.active);
    if(tag){
      if(tag.path != this.$route.path){
        if(replace){
          tag.history.push({
            path: tag.path,
            routeName: tag.routeName
          });
          console.log("history push", tag.path);
          tag.path = this.$route.path;
          if(this.$route.meta && this.$route.meta.name){
            tag.routeName = this.$route.meta.name;
          }

          TagsViewModule.addView(tag);
        } else {
          this.$router.push({path: tag.path});
          console.log("redirect", tag.path)
        }
      }
    } else {
      const route = this.$route;
      if(route){
        const routeName = route !== undefined ? route.name : "";
        const menus = this.menusMap();
        const menu = menus.get(route.meta!.menu);
        if(menu){
          TagsViewModule.addView({
            title: menu.name,
            key: menu.url,
            path: menu.url,
            routeName: routeName!,
            module: menu.moduleId,
            meta:{
              affix: menu.affix
            },
            active: true,
            history: []
          })
        }
      }
    }
    this.visitedViews.map(e=>{
      if(e.active){
        this.editableTabsValue = e.key;
      }
    })
  }

  private closeSelectedTag2(view: string) {
    const obj = this.visitedViews.find(e=>e.key == view);
    if(obj){
      this.closeSelectedTag(obj);
    }
  }
  private closeSelectedTag(view: ITagView) {
    TagsViewModule.delView(view)
    if (view.active) {
      this.toLastView(TagsViewModule.visitedViews, view)
    }
  }

  private toLastView(visitedViews: ITagView[], view: ITagView) {
    if(visitedViews.length > 0){
      const latestView = visitedViews.slice(-1)[0]
      latestView.active = true;
    }else {
      this.$router.push('/').catch(err => {
        console.warn(err)
      })
    }
  }
}
